<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-col :span="24" class="item">
                            <el-col :span="12" class="item">
                                <el-form-item label="优惠券名称"  required prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入优惠券名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="优惠券金额/元" required  prop="money">
                                    <el-input-number v-model="editForm.money" :min='0' :max="sumDiscountPrice" :precision="2" placeholder="请输入优惠券金额" :controls='false' class="inputMoneyNumber" style="width:100%;"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="优惠券状态" required  prop="status">
                                    <el-select
                                        v-model="editForm.status"
                                            style="width:100%"
                                        placeholder="请选择优惠券状态">
                                        <el-option
                                            v-for="item in statusValue"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-col>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    export default {
        name: 'Edit',
        data() {
            return {

                loading: false,
                chargeTime:'',
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    couponCode:'',
                    money:'',
                    status:''
                },
                statusValue:[
                    {
                        value: 1,
                        label: '正常'
                    },
                    {
                        value: 2,
                        label: '废弃'
                    }
                ],
                rules:{
                    money:[
                        { required: true, message: '请输入金额', trigger: 'blur' },
                    ],
                    name:[
                        { required: true, message: '请输入折扣名称', trigger: 'blur' },
                    ],
                    status:[
                        { required: true, message: '请选择状态', trigger: 'blur' },
                    ],
                }
            }
        },

        methods: {
            init(row){
                this.$refs.editForm.resetFields();
                this.editForm.name = row.name;
                this.editForm.status = row.status;
                this.editForm.money = row.money;
                this.editForm.couponCode = row.couponCode;
            },
            formatterTime(times) {
                return times.replace('T',' ').slice(0,19);
            },
            closeSelf() {
                this.$emit("closeEdit");
            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){

               
                this.loading = true;

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Coupon/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 730px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow: auto;
                .inputMoneyNumber /deep/ .el-input__inner{
                    text-align: left;
                }
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
